import React from 'react';
import HabitTracker from './components/HabitTracker';
import './App.css';

function App() {
  return (
    <div className="App">
      <HabitTracker />
    </div>
  );
}

export default App;